import * as React from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {}

/**
 * Стилизованный нативный <select>. Делаем `appearance-none` и рисуем chevron
 * абсолютным позиционированием справа, оставляя справа padding под иконку.
 *
 * Цвет фона/текста у <option> в native dropdown браузера контролируется ограниченно;
 * через arbitrary-selectors задаём тёмный фон для опций - это работает в Chromium и Firefox.
 */
const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, children, ...props }, ref) => (
    <div className="relative">
      <select
        ref={ref}
        className={cn(
          'flex h-10 w-full appearance-none rounded-md border border-white/10 bg-eol-black/40 pl-3 pr-9 text-sm text-eol-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-eol-pink/50 focus-visible:border-eol-pink/40 disabled:cursor-not-allowed disabled:opacity-50',
          '[&>option]:bg-eol-black [&>option]:text-eol-white',
          className,
        )}
        {...props}
      >
        {children}
      </select>
      <ChevronDown
        aria-hidden
        className="pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 h-4 w-4 text-eol-desc"
      />
    </div>
  ),
);
Select.displayName = 'Select';

export { Select };
